"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.is-nan");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.pInt = function (val) {
  var iVal = 0;

  if (typeof val === 'string') {
    iVal = parseInt(val, 10);

    if (Number.isNaN(iVal)) {
      iVal = 0;
    }
  } else if (typeof val !== 'undefined' && val !== null) {
    iVal = val;
  }

  return iVal;
};

exports.op = function (val, fn) {
  if (typeof val === 'undefined' || val === null) {
    return val;
  }

  var results = val.toString().trim().match(/^(\d+)?(.(\d+))?(px|rem|em)?$/i);

  if (results && results.length) {
    var full = exports.pInt(results[1]);
    var frac = exports.pInt(results[3]);
    var unit = results[4] || '';
    return "".concat(fn(full + +"0.".concat(frac))).concat(unit);
  }

  return val.toString();
};